const allowedEmailDomains = ['@traveltek.net', '@appvales.com']

export const isTestEmailDomain = (email?: string | null): boolean => {
    // PRODUCTION TEST CASE ONLY
    // when feature toggle is turned off, the content will be visible only users registered for specific domains
    if (email) {
        return Boolean(allowedEmailDomains.find((domain) => email.includes(domain)))
    } else return false
}
